import backend, {LOOM_API} from 'utils/backend/loom/api_library';

const loomApi = () => {
  if (!LOOM_API) {
    throw new Error('REACT_APP_LOOM_API must be configured before Loom invitations can be enabled.');
  }

  return LOOM_API.replace(/\/$/, '');
};

const invitationPath = (invitationId) => `${loomApi()}/api/careos/invitations/${encodeURIComponent(invitationId)}`;

// `{interview, familyAnswers: [{position, audio}]}`. Each link is `{url, expiresAt}` or null. A link
// expires after 10 minutes, so this read is never cached.
const getRecordings = (invitationId) => {
  return backend.get(`${invitationPath(invitationId)}/recordings`);
};

// Sharing is final: Loom has no route to stop sharing.
const shareWithFamily = (invitationId) => {
  return backend.post(`${invitationPath(invitationId)}/share`);
};

export default {
  getRecordings,
  shareWithFamily,
};
